<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            headerBar: false,
        }
    }, // End of Component > data
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),
        dataSegmentId() {
            // console.log('compute-main')
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.headerBar = this.$route.meta.headerBar

            // if (this.$route.params.dataSegmentId) {
            //     return this.$route.params.dataSegmentId
            // }
            return process.env.VUE_APP_RC_ACCOUNT
        },
    }, // End of Component > mounted
    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            // console.log('watch-main')
            if (value) {
                this.checkOcrSwitch()
                // this.goToFirstStep()
            }
        },
    }, // End of Component > methods
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        if (this.$route.meta.publicRegistration === true) {
            this.checkDataSegment()
        }
        this.goToFirstStep()
        this.checkOcrSwitch()
        this.$store.commit('initDefaultFields', 'form')

        this.$root.$on(
            'updateTempCustomer',
            function () {
                this.updateTemp()
            }.bind(this)
        )
    }, // End of Component > computed

    beforeDestroy() {
        this.$root.$off('updateTempCustomer', this.updateTemp())
    },

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        goToFirstStep() {
            try {
                if (
                    !['identity-document', 'new-signup'].includes(
                        this.$route.name
                    )
                ) {
                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            name: 'public-registration-init',
                            // params: {
                            //     dataSegmentId: this.dataSegmentId,
                            // },
                        })
                        // .catch(() => {})
                    } else {
                        this.$router.push({
                            name: 'identity-document',
                        })
                    }
                }
            } catch (err) {
                console.log(err)
                // this.$store.commit('setError', 'Something went wrong')
            }
        }, // End of goToFirstStep() method
        async updateTemp() {
            if (this.$route.meta.publicRegistration === true) {
                try {
                    const formData = this.$store.state.registration.form
                    // console.log('FormData: ' + formData)

                    var str = this.$store.getters.getField(
                        'identityInfo.number'
                    )
                    if (str) {
                        var newStr = str.replace(/-/g, '')
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: newStr,
                        })
                    }

                    axios
                        .post(
                            apiUrl + 'customers/temp-customer-update',
                            formData
                        )
                        .then((response) => {
                            // console.log('data', response.data)
                            // this.setValuesForRadio(this.data.data);
                            this.$store.commit('registration', {
                                key: 'form',
                                value: response.data,
                            })

                            this.$store.commit('setSuccess', response.message)
                        })
                        .catch((error) => {
                            this.errorMessage = error.message
                            this.$store.commit(
                                'setError',
                                'Something went wrong'
                            )
                            // console.error('There was an error!', error)
                        })
                } catch (err) {
                    console.log(err)
                    this.$store.commit('setError', 'Something went wrong')
                }
            }
        },

        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
                this.$store.commit('setValue', {
                    key: 'useOcr',
                    value: data.data.switch,
                })
                this.$store.commit('setValue', {
                    key: 'restrictDuplicateCustomers',
                    value: data.data.restrictDuplicateCustomers,
                })
            } catch (error) {
                // console.log(error)
            }
        }, // End of checkOcrSwitch() method

        async checkDataSegment() {
            try {
                const { data } = await request({
                    url: `${apiUrl}configurations/check-dataSegment`,
                    method: 'post',
                    data: { dataSegmentId: this.dataSegmentId },
                })

                if (data) {
                    if (data.status == 'fail') {
                        this.$router.push('/404')
                    }
                } else {
                    this.$router.push('/404')
                }
            } catch (error) {
                this.$router.push('/404')
            }
        }, // End of checkOcrSwitch() method
    }, // End of Component > watch
} // End of export default
</script>
